import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const BeneficiaryAccountFailed = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const createAccountHandler = () => {
    navigate("/beneficiary_account_dashboard/create_beneficiary_account");
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_account_dashboard");
  };

  const errorData = state?.error || state;

  const getErrorMessage = () => {
    if (typeof errorData === "string") {
      return errorData;
    }

    if (Array.isArray(errorData?.errors) && errorData.errors.length > 0) {
      const firstErrorObj = errorData.errors[0];

      const firstKey = Object.keys(firstErrorObj)[0];

      const firstError = firstErrorObj[firstKey];

      if (firstError?.base?.length > 0) {
        return firstError.base[0];
      }

      if (Array.isArray(firstError) && firstError.length > 0) {
        return firstError[0];
      }

      if (typeof firstError === "string") {
        return firstError;
      }
    }

    if (errorData?.errors && typeof errorData.errors === "object") {
      const firstKey = Object.keys(errorData.errors)[0];

      const firstError = errorData.errors[firstKey];

      if (Array.isArray(firstError)) {
        return firstError[0];
      }

      if (typeof firstError === "string") {
        return firstError;
      }
    }

    return errorData?.message || "An unknown error occurred";
  };

  const errorMessage = getErrorMessage();

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="error"
      title="Failed to create beneficiary account."
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Error details">
        <InfoCard
          bgColor="var(--negative-card)"
          rows={[
            {
              leftTitle: errorMessage,
              leftSubTitle: "Error message",
            },
          ]}
        />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default BeneficiaryAccountFailed;
